<template>
  <div>
    <div v-if="loading" class="ui active inline center inverted dimmer">
      <div class="ui text loader">{{ $t('loading') }}...</div>
    </div>
    <div class="centered-header">
      <h2 class="ui header" style="color: #092442;">
        <i class="bed icon"></i>
        <div class="content">
          Medical Machine
        </div>
      </h2>
    </div>

    <h4 class="ui horizontal divider header">
      <i class="question circle outline icon"></i>
      Main Information
    </h4>

    <div class="ui form" id="medical-machine-form">

      <div class="field">
        <label for="name">
          Name
          <strong style="color: red; font-size: 15px;">*</strong>
        </label>
        <div class="ui input">
          <input
            type="text"
            :placeholder="'name'"
            v-model="medicalMachine.name"
            name="name"
          />
        </div>
      </div>

      <div class="field">
        <label for="telephone">Origin Country</label>
        <div class="ui input left icon">
          <i class="phone icon"></i>
          <input
            type="text"
            :placeholder="'Origin Country'"
            v-model="medicalMachine.origin_country"
            name="originCountry"
          />
        </div>
      </div>

      <div class="field">
        <label for="bought_at">Bought At</label>
        <div
          style="text-align: center"
          class="ui calendar"
          :id="'bought_at'"
        >
          <div class="ui input left icon">
            <i class="calendar icon"></i>
            <input
              type="text"
              :placeholder="'Bought At'"
              readonly=""
              name="day"
            />
          </div>
        </div>
      </div>

      <div class="required field">
        <label for="weight">
          Cost amount for visits
        </label>
        <div class="ui input">
          <input
            type="number"
            :placeholder="'Cost Amount'"
            v-model.number="medicalMachine.cost_amount"
            name="costAmount"
          />
        </div>
      </div>
      
      <div class="required field">
        <label for="gender">Cost type</label>
        <select class="ui fluid search dropdown"
                id="cost-type-search"
                v-model="medicalMachine.cost_type"
                name="costType">
          <option value="">Cost type</option>
          <option :value="1">Fixed cost</option>
          <option :value="2">Percentage cost</option>
        </select>
      </div>

      <h4 class="ui horizontal divider header">
        <i class="question circle outline icon"></i>
        default Package Information
      </h4>

      <div class="field">
        <label for="gender">
          Unit Measurement
          <strong style="color: red; font-size: 15px;">*</strong>
        </label>
        <select
          class="ui fluid search dropdown"
          id="unit-measurement-search"
          v-model.number="medicalMachine.unit_measurement_id"
          name="unitMeasurement"
        >
          <option value="">Unit Measurement</option>
          <option 
            :value="unitMeasurement.id" 
            v-for="unitMeasurement in unitMeasurements"
            :key="unitMeasurement.id"
          >
            {{ unitMeasurement.name }}
          </option>
        </select>
      </div>

      <div class="field">
        <label for="weight">
          Unit Price
          <strong style="color: red; font-size: 15px;">*</strong>
        </label>
        <div class="ui input">
          <input
            type="number"
            :placeholder="'Unit Price'"
            v-model.number="medicalMachine.basic_unit_price"
            name="unitPrice"
          />
        </div>
      </div>

      <div class="ui negative message" v-if="notCreated">
        <div class="header">
          Error
        </div>
        <p>Please, Make sure you entered a valid data.</p>
      </div>

      <div
        class="ui blue right floated submit button"
        :class="{ disabled: buttonDisabled || isPressed}"
        style="background-color: #092442"
        @click="save()"
      >
        Submit
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      notCreated: false,
      buttonDisabled: true,
      isPressed: false,
      medicalMachine: {
        name: null,
        origin_country: null,
        bought_at: null,
        unit_measurement_id: null,
        basic_unit_price: null,
        cost_amount: null,
        cost_type: null
      }
    };
  },
  mounted() {
    this.initGUI();
  },
  watch: {
    medicalMachine: {
      handler: function () {
        this.buttonDisabled = ! $('#medical-machine-form').form('is valid')
      },
      deep: true
    }
  },
  methods: {
    initGUI() {
      this.$nextTick(() => {
        $('#unit-measurement-search').dropdown();
        $('#cost-type-search').dropdown();


        $('#bought_at').calendar({
          type: 'date',
          maxDate: new Date(),
          onChange: date => {
            this.medicalMachine.bought_at = date;
          }
        });

        $('#medical-machine-form').form({
          inline: true,
          on: 'blur',
          fields: {
            name: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter patient name.'
                }
              ]
            },
            unitMeasurement: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please choose unit measurement.'
                }
              ]
            },
            costType: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please choose unit measurement.'
                }
              ]
            },
            unitPrice: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter the unit price.'
                },
                {
                  type: 'number',
                  prompt: 'Please enter valid unit price.'
                }
              ]
            },
            costAmount: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter the unit price.'
                },
                {
                  type: 'number',
                  prompt: 'Please enter valid unit price.'
                }
              ]
            }
          }
        });
      });
    },
    save() {
      if ($('#medical-machine-form').form('is valid')) {
        this.loading = true
        this.isPressed = true
        this.$http.post('medical_machines', {
          medical_machine: this.medicalMachine,
          clinic_id: this.getFromLocalStorage('clinicId')
        }).then(response => {
          this.loading = false
          this.notCreated = false
          this.navigateTo('Show_Medical_Machine', { key: 'params', value: { id: response.data.id } })
        }).catch(() => {
          this.loading = false
          this.isPressed = false
          this.notCreated = true
        })
      }
    }
  }
};
</script>

<style scoped>
.centered-header {
  display: flex;
  justify-content: center;
}
.checkboxLabel {
  color: rgba(0, 0, 0, 0.87);
  font-size: 0.92857143em;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/medical_machines/NewMedicalMachine.vue